<template>
	<div class="nav-body">
		<div class="left-nav-logo" @click="toHome()">
			<img class="left-nav-logo-img" src="../assets/nav-logo.png" />
			<!-- <div class="left-nav-logo-font">灵研学术</div> -->
			<div class="right-top">
				<!-- 右侧顶部内容 -->
				<div class="right-top-nav">
					<div class="right-top-nav-model" @click="gotoLink()">首页</div>
					<div class="right-top-nav-model" @click="gotoLink('About')">关于我们</div>
				</div>
			</div>
		</div>

	</div>
</template>

<script>
	export default {
		data() {
			return {

			}
		},
		methods: {
			toHome() {
				console.log(111)
				this.$router.push({
					path: '/'
				});
			},
			gotoLink(url) {
				this.$router.push({
					name: url
				})
			},

		},

	}
</script>

<style scoped>
	.nav-body {
		width: 100%;
		height: 60px;
		position: fixed;
		top: 0;
		z-index: 199;

		/* margin-top: -64px; */

		background-color: #F5F7FC;
	}

	.left-nav-logo {
		/* Logo */

		position: absolute;
		width: 240px;
		height: 60px;
		left: 0px;
		top: 0px;
		cursor: pointer;
		/* background-color: #165DFF; */

	}

	.left-nav-logo-img {
		/* Ellipse 153 */

		position: absolute;
		width: 120px;
		height: 32px;
		left: 32px;
		top: 16px;


	}

	.header-container {
		display: flex;
		flex-direction: row;
		align-items: center;
		width: 1200px;
		margin: 0 auto;
		height: 60px;
	}


	.logo {
		/* Group 47099 */
		width: 165.88px;
		height: 41.4px;
		display: flex;
		flex-direction: row;
		align-items: center;
	}

	.logo-font {
		/* 灵岩学术 */
		width: 97.03px;
		height: 24.34px;
	}

	.logo :hover {
		cursor: pointer;
	}

	.logo-img {
		/* Group 47099 */
		width: 165.88px;
		height: 41.4px;
	}

	.right-top-nav {
		/* tabs */

		/* Auto layout */
		display: flex;
		flex-direction: row;
		align-items: center;
		padding: 0px;

		position: absolute;
		width: 272px;
		height: 60px;
		top: 1px;
		/* margin-left: 372px; */
		/* right: -2%; */
		/* left: 680px; */
	}

	.right-top-nav-model {
		/* tabs/line */

		/* Auto layout */
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
		padding: 10px 16px;
		box-sizing: border-box;
		isolation: isolate;

		/* width: 112px; */
		height: 42px;


		/* Inside auto layout */
		flex: none;
		order: 1;
		flex-grow: 0;



		font-family: 'PingFang SC';
		font-style: normal;
		font-weight: 400;
		font-size: 16px;
		line-height: 140%;
		/* or 22px */
		text-align: center;

		/* 文字/text-5 */
		color: #1D2129;

	}

	.right-top-nav-model:hover {
		cursor: pointer;
		color: #2459E5;
	}
</style>